import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import { isEmpty, get } from "lodash";
import asyncRoute from "../../helpers/hoc/asyncRoute";
import routes from "../../routes";

import { PrivateRoute } from "../../utils/route-auth";
import { PERMISSION } from "../../constants/permission";
import { isTenantAgency } from "../../selectors";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

const ListMedia = asyncRoute(() => import("./List"));
const AddCampaign = asyncRoute(() => import("./AddCampaign/Stepper"));
// const PdfScreen = asyncRoute(()=> import('./downloadPDF'))

class ATDCAMPAIGN extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openAdUnitModal: false,
      openAdUnitGroupModal: false,
      openPMPModal: false,
      openMediationModal: false,
      istenantAgency: false,
    };
  }

  componentWillMount() {
    let isAuthenticated = JSON.parse(localStorage.getItem("AuthData"));
    if (isEmpty(isAuthenticated)) {
      const { history } = this.props;
      history.push(routes.preSignIn);
    }
    let isAgencyLogin = isTenantAgency(this.props.tenantId);
    this.setState({ istenantAgency: isAgencyLogin });
  }

  render() {
    const { match } = this.props;
    const { istenantAgency } = this.state;
    // console.log(match.path,"Media")

    return (
      <div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => <ListMedia match={match} />}
          />

          {!istenantAgency && (
            <PrivateRoute
              path={`${match.path}/${routes.campaign.add}`}
              component={AddCampaign}
              permissions={[PERMISSION.CAMPAIGN.CAMPAIGN.ADD]}
              defaultRoute={"campaign"}
            />
          )}

          {!istenantAgency && (
            <PrivateRoute
              path={`${match.path}/${routes.campaign.edit}/:id`}
              component={AddCampaign}
              permissions={[PERMISSION.CAMPAIGN.CAMPAIGN.EDIT]}
              defaultRoute={"campaign"}
            />
          )}

          <PrivateRoute
            path={`${match.path}/${routes.campaign.view}/:id`}
            component={AddCampaign}
            permissions={[PERMISSION.CAMPAIGN.CAMPAIGN.VIEW]}
            defaultRoute={"campaign"}
          />

          {/* {!istenantAgency && (
            <PrivateRoute
              path={`${match.path}/${routes.campaign.view}/:id`}
              component={AddCampaign}
              permissions={[PERMISSION.CAMPAIGN.CAMPAIGN.VIEW]}
              defaultRoute={"campaign"}
            />
          )} */}
        </Switch>
      </div>
    );
  }
}

export default withRouter(
  connect((state) => ({
    tenantId: get(state, "app.preSignInState.tenantId", ""),
    userId: get(state, "app.preSignInData.userId", ""),
    authToken: get(state, "app.signInData.authToken", ""),
  }))(ATDCAMPAIGN)
);
